import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { openGoogleMap } from './enquiryUtils';

export const AddressModal = ({ show, onHide, schoolName, address, district, mapUrl }) => {
    return (
        <Modal show={show} onHide={onHide} centered className="fade">
            <Modal.Header closeButton className="py-2.5 px-3 border-bottom bg-light-subtle">
                <div className="d-flex align-items-center gap-2">
                    <span className="badge bg-soft-info text-info p-1.5 fs-14 rounded-circle">
                        <i className="ri-map-pin-2-line"></i>
                    </span>
                    <Modal.Title className="fs-15 mb-0 fw-semibold text-truncate" style={{ maxWidth: '320px' }}>
                        {schoolName || 'School'} — Address
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body className="p-3">
                <div className="mb-3">
                    <label className="text-muted fs-12 fw-medium mb-1 d-block">
                        <i className="ri-home-4-line me-1 text-primary"></i> Full Address
                    </label>
                    <div className="p-2.5 bg-light rounded border text-dark fs-13 lh-base text-break">
                        {address || 'No address provided'}
                    </div>
                </div>

                <div className="row g-2">
                    <div className="col-12 col-sm-6">
                        <label className="text-muted fs-12 fw-medium mb-1 d-block">
                            <i className="ri-building-2-line me-1 text-info"></i> District / City
                        </label>
                        <div className="fw-semibold text-dark fs-13">
                            {district || 'Not specified'}
                        </div>
                    </div>

                    {mapUrl && (
                        <div className="col-12 col-sm-6 d-flex align-items-end justify-content-sm-end">
                            <button
                                type="button"
                                className="btn btn-sm btn-soft-danger d-inline-flex align-items-center gap-1"
                                onClick={() => openGoogleMap(mapUrl)}
                            >
                                <i className="ri-map-pin-fill"></i>
                                <span>Open Google Map</span>
                            </button>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="py-2 px-3 border-top bg-light-subtle">
                <Button variant="secondary" size="sm" onClick={onHide} className="px-3">
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddressModal;
